module.exports = __webpack_public_path__ + "media/img/alhoor-favicon-ffca1037e50cefe09a61b9b1818cad30.ico";